import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

function CTA() {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const [formData, setFormData] = useState(null);
  const [loading, setLoading] = useState(false);

  const [responseMsg, setResponseMsg] = useState("");
  const [isSuccess, setIsSuccess] = useState(null);

  const [showSuccessUI, setShowSuccessUI] = useState(false);

  useEffect(() => {
    if (!formData) return;

    const sendMail = async () => {
      setLoading(true);
      setResponseMsg("");
      try {
        const res = await fetch("https://tararide.com/api/send-mail", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        });

        const data = await res.json();

        setResponseMsg(data.message);
        setIsSuccess(data.success);

        if (data.success) {
          setTimeout(() => {
            setIsOpen(false);
          }, 4000);
        }
      } catch (error) {
        console.log(error);
        setResponseMsg("Something went wrong. Please try again.");
        setIsSuccess(false);
      } finally {
        setLoading(false);
      }
    };

    sendMail();
  }, [formData]);

  const handleSubmit = (e) => {
    e.preventDefault();

    setFormData({
      name: e.target.name.value,
      email: e.target.email.value,
      phone: e.target.phone.value,
      message: e.target.message.value,
    });

    e.target.reset();
  };

  return (
    <>
      {" "}
      {/* CTA SECTION */}
      <div className="cta-sec-wrapping" id="contact">
        <div className="container">
          <h2 className="main-heading"> {t("cta_title")} </h2>
          <p> {t("cta_desc")} </p>
          <div className="d-flex gap-2 mt-4">
            {/* CALL BUTTON */}
            <a
              href="tel:+201287690960"
              className="cta-btn text-decoration-none d-flex gap-3"
            >
              <div>{t("cta_call")}</div>
              <div>
                <i className="fa-solid fa-phone"></i>
              </div>
            </a>
            {/* MESSAGE BUTTON */}
            <button
              className="cta-btn d-flex gap-3"
              onClick={() => setIsOpen(true)}
            >
              <div>{t("cta_message")}</div>
              <div>
                <i className="fa-solid fa-envelope"> </i>{" "}
              </div>
            </button>
          </div>
        </div>
      </div>
      {/* MODAL */}
      {isOpen && (
        <div className="custom-modal-overlay" onClick={() => setIsOpen(false)}>
          <div className="custom-modal" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={() => setIsOpen(false)}>
              ✕
            </button>
            <h2 className="modal-title"> Contact Us </h2>
            <form className="modal-form" onSubmit={handleSubmit}>
              <input type="text" name="name" placeholder="Full Name" required />
              <input
                type="email"
                name="email"
                placeholder="Email Address"
                required
              />
              <input
                type="tel"
                name="phone"
                placeholder="Contact Number"
                required
              />
              <textarea
                name="message"
                placeholder="Message"
                rows="4"
                required
              ></textarea>
              <button
                type="submit"
                className="wave-btn user-app"
                disabled={loading}
              >
                {loading ? "Sending..." : "Send Message"}
              </button>

              {responseMsg && (
                <p
                  style={{
                    marginTop: "10px",
                    color: isSuccess ? "#fff" : "#fd0707",
                    fontWeight: "500",
                  }}
                >
                  {responseMsg}
                </p>
              )}
            </form>
          </div>
        </div>
      )}
    </>
  );
}

export default CTA;
